import React, { useState } from "react";
import baseUrl from "../../../../api/baseUrl";
import { useDispatch } from "react-redux";
import {
  setloadeActive,
  setloadeDeactive,
} from "../../../../redux/loader/loaderActions";
import CloseIcon from "@mui/icons-material/Close";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";

function AddAllDiagnose({ close }: any) {
  const dispatch = useDispatch();
  const [colorError, setcolorError] = useState(false);

  const [formData, setformData] = useState({
    diagnose: "",
    color: "#6366f1",
    isBtn: false,
    hasSurface: true,
  });

  const handleChange = (e: any) => {
    if (e.target.type === "checkbox") {
      setformData({ ...formData, [e.target.name]: e.target.checked });
    } else {
      setcolorError(false);
      setformData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    dispatch(setloadeActive());
    baseUrl
      .post("alltreatment/createDiagnose", formData)
      .then((response) => {
        if (response.data.success) {
          dispatch(setloadeDeactive());
          close(false);
        }
      })
      .catch((error) => {
        dispatch(setloadeDeactive());
        if (error.response.status === 409) {
          setcolorError(true);
        }
        console.log(error);
      });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
      <div className="bg-white dark:bg-slate-800 rounded-2xl shadow-2xl w-full max-w-md overflow-hidden border border-slate-200 dark:border-slate-700">
        {/* Header */}
        <div className="px-6 py-4 bg-gradient-to-r from-primary to-primaryLight flex items-center justify-between">
          <div className="flex items-center gap-3">
            <LocalHospitalIcon className="text-white" sx={{ fontSize: 24 }} />
            <h2 className="text-lg font-bold text-white">Add Diagnose</h2>
          </div>
          <button
            onClick={() => close(false)}
            className="w-8 h-8 rounded-lg bg-white/20 hover:bg-white/30 flex items-center justify-center text-white transition-colors"
          >
            <CloseIcon sx={{ fontSize: 20 }} />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <div className="p-6 space-y-4">
            {/* Diagnose Name */}
            <div>
              <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">
                Diagnose Name <span className="text-red-500 dark:text-red-400">*</span>
              </label>
              <input
                type="text"
                onChange={handleChange}
                value={formData.diagnose}
                name="diagnose"
                placeholder="Enter diagnose name"
                className="w-full px-4 py-2.5 bg-slate-50 dark:bg-slate-700 border border-slate-200 dark:border-slate-600 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all text-slate-800 dark:text-slate-200 placeholder-slate-500 dark:placeholder-slate-400"
                required
              />
            </div>

            {/* Checkboxes */}
            <div className="flex gap-6">
              <label className="flex items-center gap-2 cursor-pointer">
                <input
                  type="checkbox"
                  onChange={handleChange}
                  checked={formData.isBtn}
                  name="isBtn"
                  className="hidden"
                />
                <div
                  className={`w-5 h-5 rounded flex items-center justify-center transition-colors ${
                    formData.isBtn
                      ? "bg-indigo-500 text-white"
                      : "bg-slate-200 dark:bg-slate-600 text-slate-400 dark:text-slate-500"
                  }`}
                >
                  {formData.isBtn ? (
                    <CheckBoxIcon sx={{ fontSize: 20 }} />
                  ) : (
                    <CheckBoxOutlineBlankIcon sx={{ fontSize: 20 }} />
                  )}
                </div>
                <span className="text-sm font-medium text-slate-700 dark:text-slate-300">Is Button</span>
              </label>

              <label className="flex items-center gap-2 cursor-pointer">
                <input
                  type="checkbox"
                  onChange={handleChange}
                  checked={formData.hasSurface}
                  name="hasSurface"
                  className="hidden"
                />
                <div
                  className={`w-5 h-5 rounded flex items-center justify-center transition-colors ${
                    formData.hasSurface
                      ? "bg-indigo-500 text-white"
                      : "bg-slate-200 dark:bg-slate-600 text-slate-400 dark:text-slate-500"
                  }`}
                >
                  {formData.hasSurface ? (
                    <CheckBoxIcon sx={{ fontSize: 20 }} />
                  ) : (
                    <CheckBoxOutlineBlankIcon sx={{ fontSize: 20 }} />
                  )}
                </div>
                <span className="text-sm font-medium text-slate-700 dark:text-slate-300">Has Surface</span>
              </label>
            </div>

            {/* Color Picker */}
            {formData.isBtn && (
              <div>
                <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">
                  Color
                </label>
                <div className="flex items-center gap-3">
                  <input
                    type="color"
                    onChange={handleChange}
                    value={formData.color}
                    name="color"
                    className="w-12 h-12 rounded-xl border-2 border-slate-200 dark:border-slate-600 cursor-pointer overflow-hidden bg-transparent"
                  />
                  <div className="flex-1">
                    <input
                      type="text"
                      value={formData.color}
                      onChange={handleChange}
                      name="color"
                      className="w-full px-4 py-2.5 bg-slate-50 dark:bg-slate-700 border border-slate-200 dark:border-slate-600 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all font-mono text-sm text-slate-800 dark:text-slate-200"
                    />
                  </div>
                </div>
                {colorError && (
                  <p className="mt-2 text-sm text-red-500 dark:text-red-400 font-medium">
                    Color already exists
                  </p>
                )}
              </div>
            )}
          </div>

          {/* Footer */}
          <div className="px-6 py-4 bg-slate-50 dark:bg-slate-700/50 border-t border-slate-100 dark:border-slate-600 flex justify-end gap-3">
            <button
              type="button"
              onClick={() => close(false)}
              className="px-5 py-2.5 text-slate-600 dark:text-slate-300 bg-white dark:bg-slate-600 border border-slate-200 dark:border-slate-500 rounded-xl hover:bg-slate-50 dark:hover:bg-slate-500 transition-colors font-medium"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-5 py-2.5 bg-gradient-to-r from-primary to-primaryLight text-white rounded-xl hover:shadow-lg hover:shadow-primary/20 transition-all font-medium"
            >
              Add Diagnose
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddAllDiagnose;
